import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';

type Mode = 'desktop' | 'mobile';

interface ModeContextType {
  mode: Mode;
  setMode: (mode: Mode) => void;
}

const ModeContext = createContext<ModeContextType | undefined>(undefined);

export const ModeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [mode, setMode] = useState<Mode>('desktop');

  useEffect(() => {
    try {
      const isTouch = typeof window !== 'undefined' && ('ontouchstart' in window || (navigator as any).maxTouchPoints > 0);
      const isSmall = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
      const ua = (typeof navigator !== 'undefined' ? navigator.userAgent || '' : '').toLowerCase();
      const isMobileUA = /iphone|ipad|ipod|android|mobile|miui|harmony|honor|huawei|oppo|vivo|xiaomi/.test(ua);
      if (isTouch || isSmall || isMobileUA) {
        setMode('mobile');
      }
    } catch {}
  }, []);

  return (
    <ModeContext.Provider value={{ mode, setMode }}>
      {children}
    </ModeContext.Provider>
  );
};

export const useMode = (): ModeContextType => {
  const context = useContext(ModeContext);
  if (context === undefined) {
    throw new Error('useMode must be used within a ModeProvider');
  }
  return context;
};
